
import {
    GrpcService,
    HttpRequestDelegate,
} from "../../../grpc"

import {
    Timestamp,
} from "../../../google/protobuf/timestamp"

import {
    EnumValue,
} from "../../../google/protobuf/type"

import {
    Empty,
} from "../../../google/protobuf/empty"

export interface IssueLicenseRequest {
    organizationId: number /* 组织id */
    totalCount?: number /* 剩余次数 */
    expireTime: Timestamp /* 到期时间 */
    operation: EnumValue /* 操作 */
}

export interface GetLicenseRequest {
    organizationId: number
    operation: EnumValue
}

export interface License {
    operation: EnumValue
    totalCount?: number /* 剩余次数 */
    usedCount?: number /* 已使用次数 */
    expireTime: Timestamp /* 到期时间 */
}

export interface ListOperationsRequest {
}

export interface ListOperationsResponse {
    operations: Array<EnumValue>
}

export interface UpdateLicenseRequest {
    organizationId: number /* 组织id */
    totalCount?: number /* 剩余次数 */
    expireTime: Timestamp /* 到期时间 */
    operation: EnumValue /* 操作 */
}

export interface BatchGetLicensesRequest {
    operation: EnumValue
    organizationIds: Array<number>
}

export interface BatchGetLicensesResponse {
    licenseInfos: Array<LicenseInfo>
}

export interface LicenseInfo {
    organizationId: number
    license: License
}

export interface GetOrganizationLicensesRequest {
    organizationId: number
}

export interface GetOrganizationLicensesResponse {
    operation: EnumValue
    totalCount?: number /* 剩余次数 */
    usedCount?: number /* 已使用次数 */
    expireTime: Timestamp /* 组织到期时间 */
}

export interface BatchGetOrganizationLicensesRequest {
    organizationIds: Array<number>
}

export interface BatchGetOrganizationLicensesResponse {
    organizationLicense: Array<OrganizationLicense>
}

export interface OrganizationLicense {
    organizationId: number
    operation: EnumValue
    totalCount?: number /* 剩余次数 */
    usedCount?: number /* 已使用次数 */
    expireTime: Timestamp /* 组织到期时间 */
}

export class LicenseService extends GrpcService {
    constructor(host: string, httpRequestDelegate: HttpRequestDelegate) {
        super(host, httpRequestDelegate)
    }
    
    /* 添加或修改 */
    async issueLicense(request: IssueLicenseRequest): Promise<Empty> {
        const method = "post"
        const path = "/scanner.v2.LicenseService/IssueLicense"
        return await this.call(method, path, request) as Empty
    }
    
    async getLicense(request: GetLicenseRequest): Promise<License> {
        const method = "post"
        const path = "/scanner.v2.LicenseService/GetLicense"
        return await this.call(method, path, request) as License
    }
    
    async listOperations(request: ListOperationsRequest): Promise<ListOperationsResponse> {
        const method = "post"
        const path = "/scanner.v2.LicenseService/ListOperations"
        return await this.call(method, path, request) as ListOperationsResponse
    }
    
    /* 更新 */
    async updateLicense(request: UpdateLicenseRequest): Promise<License> {
        const method = "post"
        const path = "/scanner.v2.LicenseService/UpdateLicense"
        return await this.call(method, path, request) as License
    }
    
    /* 批量获取license */
    async batchGetLicenses(request: BatchGetLicensesRequest): Promise<BatchGetLicensesResponse> {
        const method = "post"
        const path = "/scanner.v2.LicenseService/BatchGetLicenses"
        return await this.call(method, path, request) as BatchGetLicensesResponse
    }
    
    /* 根据组织id拿到所有license */
    async getOrganizationLicenses(request: GetOrganizationLicensesRequest): Promise<GetOrganizationLicensesResponse> {
        const method = "post"
        const path = "/scanner.v2.LicenseService/GetOrganizationLicenses"
        return await this.call(method, path, request) as GetOrganizationLicensesResponse
    }
    
    /* 批量根据组织id拿到所有license */
    async batchGetOrganizationLicenses(request: BatchGetOrganizationLicensesRequest): Promise<BatchGetOrganizationLicensesResponse> {
        const method = "post"
        const path = "/scanner.v2.LicenseService/BatchGetOrganizationLicenses"
        return await this.call(method, path, request) as BatchGetOrganizationLicensesResponse
    }
    
}
